"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wildcard = void 0;
var matcher_1 = require("matcher");
var Wildcard = /** @class */ (function () {
    function Wildcard(_channel) {
        var _this = this;
        this._channel = _channel;
        this._subscribers = [];
        this._isDestroyed = false;
        this._onMessage = function (event, payload, ref) {
            var finalPayload = payload;
            if (_this._initialOnMessageCallback) {
                finalPayload = _this._initialOnMessageCallback(event, payload, ref);
            }
            if (event) {
                _this._subscribers.forEach(function (sub) {
                    if (matcher_1.isMatch(event, sub.glob)) {
                        sub.cb(event, finalPayload, ref);
                    }
                });
            }
            return finalPayload;
        };
        if (!_channel) {
            throw new Error('Phoenix channel is required');
        }
        this._initialOnMessageCallback = this._channel.onMessage;
        this._channel.onMessage = this._onMessage;
    }
    Wildcard.prototype.on = function (glob, cb) {
        this._throwErrorIfDestroyed();
        this._subscribers.push({ glob: glob, cb: cb });
    };
    Wildcard.prototype.off = function (glob, cb) {
        this._throwErrorIfDestroyed();
        var idx = this._subscribers.findIndex(function (sub) {
            if (sub.cb !== cb) {
                return false;
            }
            if (Array.isArray(glob) && Array.isArray(sub.glob)) {
                return glob.every(function (pattern, idx) { return pattern === sub.glob[idx]; });
            }
            return glob === sub.glob;
        });
        if (idx !== -1) {
            this._subscribers.splice(idx, 1);
        }
    };
    Wildcard.prototype.destroy = function () {
        this._throwErrorIfDestroyed();
        this._subscribers = [];
        this._channel.onMessage = this._initialOnMessageCallback;
        this._channel = undefined;
        this._initialOnMessageCallback = undefined;
        this._isDestroyed = true;
    };
    Object.defineProperty(Wildcard.prototype, "isDestroyed", {
        get: function () {
            return this._isDestroyed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Wildcard.prototype, "channel", {
        get: function () {
            return this._channel;
        },
        set: function (channel) {
            this._channel = channel;
            this._initialOnMessageCallback = channel.onMessage;
            channel.onMessage = this._onMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Wildcard.prototype, "subscribers", {
        get: function () {
            return this._subscribers;
        },
        enumerable: false,
        configurable: true
    });
    Wildcard.prototype._throwErrorIfDestroyed = function () {
        if (this._isDestroyed) {
            throw new Error('This Wildcard instance is destroyed. Create a new one.');
        }
    };
    return Wildcard;
}());
exports.Wildcard = Wildcard;
//# sourceMappingURL=index.js.map